export default [
  // 操作指南
  {
    path: '/guide',
    component: () => import('../../views/guide/Index.vue'),
    name: 'guide',
    meta: {
      translateKey: 'cfmoto.helpCenter',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // 息屏引导
  {
    path: '/guide-restScreen',
    component: () => import('../../views/guide/restScreen/Index.vue'),
    name: 'guide-restScreen',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // 功能概览
  {
    path: '/guide-overview',
    component: () => import('../../views/guide/Overview.vue'),
    name: 'guide-overview',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 我的帐号
  {
    path: '/guide-account',
    component: () => import('../../views/guide/Account.vue'),
    name: 'guide-account',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 我的车辆
  {
    path: '/guide-vehicle',
    component: () => import('../../views/guide/Vehicle.vue'),
    name: 'guide-vehicle',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车辆仪表设置
  {
    path: '/guide-meterSetting',
    component: () => import('../../views/guide/MeterSetting.vue'),
    name: 'guide-meterSetting',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车辆设置
  {
    path: '/guide-vehicleSetting',
    component: () => import('../../views/guide/VehicleSetting.vue'),
    name: 'guide-vehicleSetting',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 寻车导航
  {
    path: '/guide-findNavigation',
    component: () => import('../../views/guide/FindNavigation.vue'),
    name: 'guide-findNavigation',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车辆导航
  {
    path: '/guide-vehicleNnavigation',
    component: () => import('../../views/guide/VehicleNnavigation.vue'),
    name: 'guide-vehicleNnavigation',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 骑行记录
  {
    path: '/guide-cyclingRecord',
    component: () => import('../../views/guide/CyclingRecord.vue'),
    name: 'guide-cyclingRecord',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 设备码查看
  {
    path: '/guide-deviceCode',
    component: () => import('../../views/guide/DeviceCode.vue'),
    name: 'guide-deviceCode',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'white',
      translateKey: 'cfmoto.deviceTitle',
    },
  },
  // 车辆体检
  {
    path: '/guide-vehicleExperience',
    component: () => import('../../views/guide/VehicleExperience.vue'),
    name: 'guide-vehicleExperience',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 使用设置
  {
    path: '/guide-useSetting',
    component: () => import('../../views/guide/UseSetting.vue'),
    name: 'guide-useSetting',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 消息通知
  {
    path: '/guide-notice',
    component: () => import('../../views/guide/Notice.vue'),
    name: 'guide-notice',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 关于我们
  {
    path: '/guide-about',
    component: () => import('../../views/guide/About.vue'),
    name: 'guide-about',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
];
